export const validateSLTP = ({
  type, // 'sl' or 'tp'
  value,
  entryPrice,
  side,
  livePrice, // expects { bid, ask }
}) => {
  // ✅ Skip validation if empty
  if (value === undefined || value === null || value.toString().trim() === "") {
    return ""; // No error for empty
  }

  const val = parseFloat(value);
  const entry = parseFloat(entryPrice);
  const bid = parseFloat(livePrice?.bid || 0);
  const ask = parseFloat(livePrice?.ask || 0);

  const str = val.toString().trim();
  if (/[^0-9.]/.test(str)) {
    return "Only numeric values allowed";
  }

  if (type === "tp") {
    if (side === "long") {
      if (val <= entry) {
        return "Take profit must be above entry price.";
      }
      if (val <= bid) {
        return "Take profit must be above current bid.";
      }
    } else {
      if (val >= entry) {
        return "Take profit must be below entry price.";
      }
      if (val >= ask) {
        return "Take profit must be below current ask.";
      }
    }
  }

  if (type === "sl") {
    if (side === "long") {
      if (val >= entry) {
        return "Stop loss must be below entry price.";
      }
      if (val >= bid) {
        return "Stop loss must be below current bid.";
      }
    } else {
      if (val <= entry) {
        return "Stop loss must be above entry price.";
      }
      if (val <= ask) {
        return "Stop loss must be above current ask.";
      }
    }
  }

  return ""; // No error
};

export const isValidNumericInput = (val, min = 0.000000001) => {
  if (!val) return { valid: false, message: "This field is required." };
  if (val < 0) return { valid: false, message: "Negative values not allowed." };
  const str = val.toString().trim();
  if (/[^0-9.]/.test(str)) {
    return {
      valid: false,
      message: "Only numeric values allowed",
    };
  }
  if (/[^0-9.]/.test(val))
    return { valid: false, message: "Enter a valid amount." };
  if ((val.match(/\./g) || []).length > 1)
    return { valid: false, message: "Only one decimal point allowed." };
  if (parseFloat(val) < min)
    return { valid: false, message: `Value must be greater then zero.` };
  return { valid: true, message: "" };
};
